import { createUseStorageState } from '../createUseStorageState';
var useLocalStorageState = createUseStorageState(typeof window === 'object' ? window.localStorage : null);
export default useLocalStorageState;